module.exports = __webpack_public_path__ + "img/safe-box.a3beff08.png";